import Vue from "vue";
import Vuetify from "vuetify/lib";
import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
    breakpoint: {
        thresholds: {
            xs: 600,
            sm: 960,
            md: 1280,
            lg: 7680, // Change break point at @/sass/variables.scss
        }
    },
    theme: {
        themes: {
            light: {
                primary: '#0f7b69', // blue darken-2
                secondary: '#424242',
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',
            },
        },
        options: {
            customProperties: true,
        }
    },
});
